import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./table1.css";
import { getLatestUpdated } from "../Components/CommonFunction";
import moment from "moment";

const CANVAS_WIDTH = 1920;
const CANVAS_HEIGHT = 1080;
const UPDATED_LINE_HEIGHT = 60;
const HEADER_ROW_HEIGHT = 80;
const UPDATED_FONT_SIZE = 40;
const MAX_BODY_FONT_SIZE = 80;

const TableData4 = () => {
  const reduxData = useSelector((state) => state.MetalDataReducer.data);
  const [data, setData] = useState([]);
  const [scale, setScale] = useState(1);
  const [canvasHeight, setCanvasHeight] = useState(CANVAS_HEIGHT);

  useEffect(() => {
    const filteredData = reduxData.filter((item) => item.product_name !== "Gold 23" && item.product_name !== "Gold 23.5");
    setData(filteredData);
  }, [reduxData]);

  useEffect(() => {
    const fitToScreen = () => {
      const nextScale = window.innerWidth / CANVAS_WIDTH;
      setScale(nextScale);
      setCanvasHeight(window.innerHeight / nextScale);
    };

    fitToScreen();
    window.addEventListener("resize", fitToScreen);
    window.addEventListener("orientationchange", fitToScreen);
    return () => {
      window.removeEventListener("resize", fitToScreen);
      window.removeEventListener("orientationchange", fitToScreen);
    };
  }, []);


  const tableHeight = canvasHeight - UPDATED_LINE_HEIGHT;
  const rowHeight = (tableHeight - HEADER_ROW_HEIGHT) / Math.max(data.length, 1);
  const bodyFontSize = Math.max(Math.min(MAX_BODY_FONT_SIZE, rowHeight * 0.62), 12);

  const latestUpdated = getLatestUpdated(data);

  return (
    <div className="gss-table-viewport">
      <div
        className="gss-table-canvas"
        style={{
          width: `${CANVAS_WIDTH}px`,
          height: `${canvasHeight}px`,
          transform: `scale(${scale})`,
          "--gss-table-height": `${tableHeight}px`,
          "--gss-body-font": `${bodyFontSize.toFixed(1)}px`,
        }}
      >
        <div
          style={{
            height: `${UPDATED_LINE_HEIGHT}px`,
            paddingRight: "20px",
            textAlign: "right",
            fontWeight: "bold",
            fontSize: `${UPDATED_FONT_SIZE}px`,
          }}
        >
          Updated On: {latestUpdated ? moment(latestUpdated.updated).format("YYYY-MM-DD hh:mm:ss A"): "-"}
        </div>

        <table className="table22">
          {/* <caption>Statement Summary</caption> */}
          <thead>
            <tr>
              <th scope="col">Metal Type</th>
              <th scope="col">Sale Rate per gm</th>
              <th scope="col">Purchase Rate per gm</th>
              {/* <th scope="col">Period</th> */}
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              return (
                <tr key={item.product_name}>
                  <td data-label="Metal Type">
                    {/* // product name is silver 0 then silver article else if silver 100 then silver bar else as it is */}
                    {item.product_name === "Silver 0" ? (
                      "Silver Article"
                    ) : item.product_name === "silver 100" ? (
                      "Silver Bar"
                    ) : (
                      <>{ item.product_name}T</>
                    )}
                  </td>
                  <td data-label="Sale Rate per gm">

                      { Number(item.sale_amount).toFixed(2)}
                  </td>

                   {/* {item.sale_amount % 1 === 0
                      ? `${item.sale_amount}.0`
                      : item.sale_amount} */}

                  {/* <td data-label="Sale Rate per gm">{Math.round(item.sale_amount)}</td> */}

                  <td data-label="Purchase Rate per gm">
                    {Number(item.purchase_amount).toFixed(2)}
                    {/* {item.purchase_amount} */}
                    {/* {item.purchase_amount % 1 === 0
                      ? `${item.purchase_amount}.0`
                      : item.purchase_amount} */}
                  </td>
                  {/* <td data-label="Period">03/01/2016 - 03/31/2016</td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableData4;